import React from "react";

/**
 * Shared hero banner for every Studio detail page. Shows the title, subtitle,
 * and an optional intro paragraph. Styled through each Studio's own CSS — this
 * just provides the slot structure so layouts stay consistent across Studios.
 */
export default function StudioHero({ title, subtitle, description, actions }) {
  return (
    <div className="studio-hero">
      <div className="studio-hero-content">
        {subtitle && <div className="studio-hero-eyebrow">{subtitle}</div>}
        <h1 className="studio-hero-title">{title}</h1>
        {description && (
          <p className="studio-hero-description">{description}</p>
        )}
      </div>
      {actions && <div className="studio-hero-actions">{actions}</div>}
    </div>
  );
}
